import { createContext } from "react";

type PanelStackContextValue = {
  currentPageId: string;
  // Which way the pages last moved: a pushed page slides in from the right, a popped one slides back out to it
  lastMove: "push" | "pop";
  push: (pageId: string) => void;
  pop: () => void;
};

// The pages open in a panel, for moving between them
export const PanelStackContext = createContext<PanelStackContextValue | null>(null);
